module.exports = __webpack_public_path__ + "static/media/social_share_icon.e73d4abf.svg";